const useUrlHash = () => {
  if (typeof window !== 'undefined') {
    const { hash } = window.location;
    const hashToObject = hash
      .replace('#', '')
      .split('&')
      .reduce((acc, item) => {
        const [key, value] = item.split('=');
        return { ...acc, [key]: value };
      }, {});

    return hashToObject;
  }

  return {};
};

export default useUrlHash;
